// Root actions
import axios from 'axios'
import offline from '../offline/index'
import helpers from '../../utils/helpers'

export default {
  fetch({ commit, state }, context) {
    const opts = {
      enableHighAccuracy: true
    }

    return new Promise((resolve, reject) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          pos => {
            const params = helpers.positionToPlain(pos)

            // Set to vue store and offline storage (doesn't matter, if we will complete sending to server or not)
            commit('SET_LATEST', params)

            offline.latestPosition(params)
            return resolve(pos)
          },
          err => {
            // err.code:
            // 0 - unknown
            // 1 - no permission to geo location yet
            // 2 - no signal (can't identify location)
            // 3 - timeout on geo-lookup (quite similar to 2)
            console.error('Location Error', err)
            return reject(err)
          },
          opts
        )
      } else {
        reject('Geo location not available in navigator')
      }
    })
  },

  record({ commit, state }, pos) {
    const params = helpers.positionToPlain(pos)
    params.eta = pos.eta
    commit('SET_LATEST', params)
    offline.latestPosition(params)
    // Set to vue store and offline storage (doesn't matter, if we will complete sending to server or not)
    return axios
      .post(process.env.VUE_APP_API_URL + '/locations', params)
      .then(response => {
        offline.attemptToSyncPosition(response, params)
        return response
      })
  },

  // Sync data from offline
  syncFromOffline(context, data) {
    return axios
      .post(process.env.VUE_APP_API_URL + '/locations/offline', {
        offline: data
      })
      .then(response => {
        // offline.clearSyncQueueForCall(response)
        const guids = _.map(response.data.data, function(item) {
          return item.guid
        })
        offline.clearPositions(guids)
        return response
      })
  },

  // Apply initial state for store
  applyInitialState({ commit }, payload) {
    commit('SET_LATEST', payload.latestPos)
  },

  directions({ commit }, payload) {
    const directionsService = new window.google.maps.DirectionsService()
    const request = {
      origin: payload.origin,
      destination: payload.destination,
      travelMode: 'DRIVING'
    }
    return new Promise((resolve, reject) => {
      directionsService.route(request, function(response, status) {
        if (status === 'OK') {
          commit('SET_DIRECTIONS', {
            callId: payload.callId,
            directions: response
          })
          return resolve(response)
        } else {
          return reject('Could not set directions')
        }
      })
    })
  },

  eta({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const service = new window.google.maps.DistanceMatrixService()
      service.getDistanceMatrix(
        {
          origins: [payload.origin],
          destinations: [payload.destination],
          travelMode: 'DRIVING',
          // transitOptions: process.env.VUE_APP_TRANSITOPTIONS ? process.env.VUE_APP_TRANSITOPTIONS : {},
          // drivingOptions: process.env.VUE_APP_DRIVINGOPTIONS ? process.env.VUE_APP_DRIVINGOPTIONS : {},
          // unitSystem: process.env.VUE_APP_UNITSYSTEM ? process.env.VUE_APP_UNITSYSTEM : {},
          avoidHighways: false,
          avoidTolls: false
        },
        function(response, status) {
          if (status === 'OK') {
            const eta = response.rows[0].elements[0]
            commit('SET_ETA', { callId: payload.callId, eta: eta })
            commit('SET_DISTANCE_TO_SITE', eta.distance)
            return resolve(eta)
          }
        }
      )
    }).catch(err => {
      console.error('ETA Error', err)
    })
  }
}
